import { useEffect, useRef } from "react";

// Zoom a due dita del CORPO mail per "ingrandimento del testo" (il contenuto si riadatta, niente ritagli):
// due dita = cambia il fattore 1x–max, doppio tocco = torna a 1x. Il valore resta memorizzato per le mail successive.
// Funziona anche con il dito dentro l'iframe del corpo HTML (same-origin) e su iOS Safari (eventi gesture nativi).
const KEY = "mailapp_zoom_corpo";
export const ZOOM_MAX = 4;
// Zoom nativo: due dita allargano TUTTA la vista (PWA); l'ingrandimento del solo testo non viene più intercettato
export const ZOOM_NATIVO = true;
export const ZOOM_MIN = 0.8;

export function leggiZoom() {
  if (ZOOM_NATIVO) return 1;
  const v = parseFloat(localStorage.getItem(KEY));
  return v >= ZOOM_MIN && v <= ZOOM_MAX ? v : 1;
}

export default function usePinchZoom(wrapRef, onScala, { max = ZOOM_MAX, frameLoad = 0, chiave = "" } = {}) {
  const cb = useRef(onScala);
  cb.current = onScala;
  const scala = useRef(ZOOM_NATIVO ? 1 : leggiZoom());

  useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap || ZOOM_NATIVO) return;
    const applica = (s) => {
      s = Math.min(max, Math.max(ZOOM_MIN, Math.round(s * 20) / 20));
      if (s === scala.current) return;
      scala.current = s;
      localStorage.setItem(KEY, String(s));
      cb.current?.(s);
    };
    const dist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    let d0 = 0;
    let s0 = 1;
    let lastTap = 0;
    const onStart = (e) => {
      if (e.touches.length === 2) {
        d0 = dist(e.touches);
        s0 = scala.current;
      } else if (e.touches.length === 1) {
        const now = Date.now();
        if (now - lastTap < 300 && scala.current !== 1) applica(1);
        lastTap = now;
      }
    };
    const onMove = (e) => {
      if (e.touches.length === 2 && d0) {
        e.preventDefault();
        applica((s0 * dist(e.touches)) / d0);
      }
    };
    const onEnd = (e) => {
      if (e.touches.length < 2) d0 = 0;
    };
    // iOS Safari: eventi gesture nativi con il fattore già calcolato; preventDefault blocca lo zoom dell'intera pagina
    const onGStart = (e) => {
      e.preventDefault();
      s0 = scala.current;
    };
    const onGChange = (e) => {
      e.preventDefault();
      if (e.scale) applica(s0 * e.scale);
    };
    const onGEnd = (e) => e.preventDefault();

    const bersagli = [wrap];
    wrap.querySelectorAll("iframe").forEach((f) => {
      try {
        const d = f.contentDocument;
        if (d?.body) {
          d.body.style.touchAction = "pinch-zoom pan-x pan-y";
          bersagli.push(d);
        }
      } catch (x) {
        console.debug("usePinchZoom: iframe non accessibile", x);
      }
    });
    const ev = [
      ["touchstart", onStart, { passive: true }],
      ["touchmove", onMove, { passive: false }],
      ["touchend", onEnd, { passive: true }],
      ["touchcancel", onEnd, { passive: true }],
      ["gesturestart", onGStart, { passive: false }],
      ["gesturechange", onGChange, { passive: false }],
      ["gestureend", onGEnd, { passive: false }],
    ];
    bersagli.forEach((b) => ev.forEach(([n, h, o]) => b.addEventListener(n, h, o)));
    return () => bersagli.forEach((b) => ev.forEach(([n, h]) => b.removeEventListener(n, h)));
  }, [wrapRef, max, frameLoad, chiave]);

  return scala;
}
